var Reverb = window.Reverb || {};

Reverb.OpenLightboxOnLoad = (function () {
  var openLightbox = '[data-open-lightbox-onload]';

  function openLightboxOnLoad() {
    var $lightbox = $(openLightbox);

    if ($lightbox.length > 0) {
      $.fancybox($lightbox);
    }
  }

  return {
    openLightboxOnLoad: openLightboxOnLoad
  };
})();

$(function () {
  Reverb.OpenLightboxOnLoad.openLightboxOnLoad();
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/open_lightbox_on_load.js